import {Component, EventEmitter, Input, Output} from '@angular/core';

import {RegionService} from "@app/areas/auth/services/region.service";
import {SupportedRegion} from "@app/areas/auth/models/supported-region.interface";
import {IdentityUserRegion} from "@app/areas/users/models/identity-user.interface";

@Component({
  selector: 'app-region-selection',
  standalone: true,
  imports: [],
  templateUrl: './region-selection.component.html',
  styleUrls: ['./region-selection.component.scss']
})
export class RegionSelectionComponent {
  /**
   * Allow a default non-selected region, indicating to the user that they need to make a selection
   */
  @Input() allowNoSelection = false
  @Input() selectedRegion: IdentityUserRegion;
  @Output() regionSelected = new EventEmitter<SupportedRegion>();

  constructor(public regionService: RegionService) {
  }

  handleRegionChange($event): void {
    const value = $event.target.value;

    const r = this.regionService.supportedRegions.find(e => e.id === value)
    this.regionSelected.emit(r)
  }
}
